import { render, staticRenderFns } from "./GeneralEditingDocument.vue?vue&type=template&id=583f9f65&scoped=true&"
import script from "./GeneralEditingDocument.vue?vue&type=script&lang=js&"
export * from "./GeneralEditingDocument.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEditingDocument.vue?vue&type=style&index=0&id=583f9f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f9f65",
  null
  
)

export default component.exports